import React from 'react';
import { Row, Col, Image, Button, Card } from 'react-bootstrap';
import LinkBtn from '../../components/Utils/Button/LinkBtn';

const Field = ({ label, value, xs = 12, md = 2 }) => (
  <Col xs={xs} md={md} className="mb-3">
    <div className="d-flex flex-column mb-3">
      <span className="type">{label}</span>
      <span className={`answer ${!value ? 'text-grey' : ''}`}>{value || 'No Aplica'}</span>
    </div>
  </Col>
);

const SelectionProcessInfoPublic = ({ selectionProcess, company, setStep }) => {
  const {
    name,
    optionalKnowledge,
    description,
    desiredKnowledge,
    jobDescription,
    jobManagement,
    jobTitle,
    selectionProcessStagesAttributes,
    startDate,
    parsedSuggestedSalary,
    translatedExpertiseLevel,
    translatedProcessType,
    translatedRemote,
    translatedStatus,
    translatedWorkSchedule,
    vacancies
  } = selectionProcess || {};

  return (
    <>
      <Row className="my-3">
        <Col md={1}>
          <div className="selection-header">
            <Image rounded className="img" src={company?.businessLogo?.fileUrl} />
          </div>
        </Col>
        <Col md={10} className="d-flex align-items-center pt-3 pl-4">
          <h4 className="text-uppercase text-dark mt-2">{company?.businessName}</h4>
        </Col>
      </Row>

      <Col md={12}>
        <Card>
          <Card.Body>
            <h2 className="mb-4">{name}</h2>
            <Row>
              <Field label="Estado:" value={translatedStatus} />
              <Field label="Fecha de Inicio:" value={startDate} />
              <Field label="Cargo:" value={jobTitle?.label} />
              <Field label="Área:" value={jobManagement?.label} />
              <Field label="Vacantes:" value={vacancies != null ? String(vacancies) : ''} />
              <Field label="Tipo de Jornada:" value={translatedWorkSchedule} />
            </Row>

            <Row>
              <Field label="Salario Sugerido:" value={parsedSuggestedSalary} />
              <Field label="Modalidad:" value={translatedRemote} />
              <Field label="Nivel de Experiencia:" value={translatedExpertiseLevel} />
              <Field label="Tipo de proceso:" value={translatedProcessType} />
              <Field
                label="N° de Etapas:"
                value={
                  Array.isArray(selectionProcessStagesAttributes)
                    ? String(selectionProcessStagesAttributes.length)
                    : '0'
                }
              />
            </Row>

            <Row>
              <Field label="Descripción:" value={description} md="12" />
            </Row>

            <Row>
              <Field label="Funcionalidad del cargo:" value={jobDescription} md="12" />
            </Row>

            <Row>
              <Field label="Conocimientos deseables:" value={desiredKnowledge} md="12" />
            </Row>

            <Row>
              <Field label="Conocimientos Opcionales:" value={optionalKnowledge || 'No Aplica'} md="12" />
            </Row>
          </Card.Body>
        </Card>
      </Col>

      <Col md={{ span: 2, offset: 10 }} className="selection-container mb-2">
        <div className="mt-auto d-flex justify-content-center">
          {selectionProcess.status !== 'active' ? (
            <div>
              <p>Lo sentimos, este proceso no está disponible.</p>
              <LinkBtn variant="primary" className="d-flex justify-content-center" to="/">
                Conoce más sobre PeopleWork
              </LinkBtn>
            </div>
          ) : (
            <Button variant="primary" className="mt-3" onClick={() => setStep(1)}>
              Postular a este cargo
            </Button>
          )}
        </div>
      </Col>
    </>
  );
};

export default SelectionProcessInfoPublic;
